<template>
<div class="box mb-5">
  <!-- <pre>{{sequences}}</pre> -->
  <!-- <template v-if="sequences">
      <pre v-for="(sequence, index) in sequences" :key="sequence.info.title_en">Total {{index}} : {{sequence.total}}</pre>
      <pre v-for="(sequence, index) in sequences" :key="sequence.info.title_fr">Done {{index}} : {{sequence.done}}</pre>
    </template> -->
  <div class="box-header d-block d-md-flex row align-center justify-space-between">
    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between
    >
      <h3 class="mb-3 mb-md-0">{{ $t("total-audit-progress.title") }}</h3>
      <v-spacer></v-spacer>
      <legend class="pl-2 legend d-block layout row d-md-flex align-center justify-space-between">
        <span class="legend-item mr-md-3 mb-1 mb-md-0 d-block d-md-flex mw-50"><span class="dots mr-1"></span> {{ $t("total-audit-progress.legend-1") }}</span>
        <span class="legend-item mr-md-3 mb-1 mb-md-0 d-block d-md-flex mw-50"><span class="dots dots-success mr-1"></span> {{ $t("total-audit-progress.legend-2") }}</span>
        <span class="legend-item mr-md-3 mb-1 mb-md-0 d-block d-md-flex mw-50"><span class="dots dots-warning mr-1"></span> {{ $t("total-audit-progress.legend-3") }}</span>
        <span class="legend-item mr-md-3 mb-1 mb-md-0 d-block d-md-flex mw-50"><span class="dots dots-white mr-1"></span> {{ $t("total-audit-progress.legend-4") }}</span>
      </legend>
    </v-layout>
  </div>

  <div class="box-content pa-4">
    <div class="mb-3" v-for="(sequence, index) in sequences" :key="index">
      <v-layout
        d-block
        d-md-flex
        row
        ma-0
        align-center
        justify-space-between
        class="mb-7 mb-md-0"
      >
        <!-- <pre>TOTAL : {{sequence.total}}</pre>
        <pre>DONE : {{sequence.done}}</pre> -->
        <v-flex xs12 md3 pr-5>
          <!-- <router-link
            class="step link"
            :to="{
              name: 'edit-audit',
              params: {
              answerid: answerid,
              sequenceid: sequenceid,
              firmid: firmid,
              gridviews: 'simple',
              tab: sequence.info['title_en'] === rootSurvey.sequences[index]['title_en'] &&
                   sequence.info['title_fr'] === rootSurvey.sequences[index]['title_fr'] &&
                   sequence.info['title_nl'] === rootSurvey.sequences[index]['title_nl'] ?
                   rootSurvey.sequences[index] : null
            }}"
            v-html="sequence.info[`title_${$i18n.locale}`]"
          ></router-link> -->
          <small v-html="sequence.info[`title_${$i18n.locale}`]"></small>
        </v-flex>


        <v-flex xs12 md7>
          <ProgressBar
            :progress="parseInt(sequence.done.point)"
            :objectif="parseInt(sequence.total.point)"
            :minimum="parseInt(sequence.total.requiredpt)"
            :donemandatoryq="parseInt(sequence.done.mandatoryq)"
            :mandatoryq="parseInt(sequence.total.mandatoryq)"
          ></ProgressBar>
        </v-flex>

        <v-flex xs12 md2 pl-0 pl-md-3>
          <small class="step small" v-if="parseInt(sequence.total.mandatoryq) - parseInt(sequence.done.mandatoryq) > 0">
            {{ `${parseInt(sequence.total.mandatoryq) - parseInt(sequence.done.mandatoryq)} ${$t("total-audit-progress.mandatoryq")}` }}
          </small>
          <small class="step small" v-else-if="parseInt(sequence.total.requiredpt) - parseInt(sequence.done.point) > 0">
            {{ `${parseInt(sequence.total.requiredpt) - parseInt(sequence.done.point)} ${$t("total-audit-progress.misspoint")}` }}
          </small>
          <!-- <small class="status success" v-else-if="parseInt(sequence.total.mandatoryq) - parseInt(sequence.done.question) <= 0">
            done
          </small> -->
        </v-flex>
      </v-layout>
    </div>

    <div class="text-center pt-3">
      <v-btn
        outlined
        rounded
        color="primary"
        class="fetch"
        :to="{
          name: 'edit-audit',
          params: {
          answerid: answerid,
          sequenceid: sequenceid,
          firmid: firmid
        }}"
      >
        {{ $t("total-audit-progress.cta") }}
      </v-btn>
    </div>
  </div>
</div>
</template>

<script>
import { showSequence } from '@/js/survey/showSequence'
import ProgressBar from '@/components/progress/ProgressBar'

export default {
  props: {
    rootSurvey: Object,
    sequences: Array | Object,
    answerid: String,
    sequenceid: String,
    firmid: String
  },

  components: {
    ProgressBar: ProgressBar
  }

  // data () {
  //   return {
  //     sequences: []
  //   }
  // },

  // created () {
  //   // Init: Get all the first sequences lvl
  //   if (!this.$store.getters['auth/isAuthenticated']) return

  //   this.rootSurvey.sequences.forEach(async (sequence) => {
  //     const params = {
  //       answerid: this.answerid,
  //       path: sequence.path,
  //       sequenceid: sequence.id,
  //       key: this.$store.state.auth.token
  //     }
  //     await showSequence(params)
  //       .then(response => {
  //         this.sequences.push(response)
  //       })
  //       .catch(error => {
  //         console.log(error)
  //       })
  //   })
  // }
}
</script>
